<div class="videoPlayer" [ngClass]="{modalVideo: modalVideo}">
    <div class="videoPlayer__wrapper" (click)="playPauseVideo()" *ngIf="!isPlaying">
        <!-- <img [src]="playImg" [ngStyle]="equipmentProviderInActive ? {'filter': 'brightness(1.2) invert(1)', 'height': '35px', 'width': '35px'} : {}"> -->
        <img [src]="playImg" *ngIf="!equipmentProviderInActive">

    </div>
    <video #video [ngClass]="{'disabled':isDisabled}" preload="none"
    [poster]=
    "content?.preview?.data?.attributes?.url"
     class="video" (click)="playPauseVideo()" (timeupdate)="changeDuration()" (loadedmetadata)="changeDuration()"></video>
    <div class="videoPlayer__controls" *ngIf="isDisabled == false">
        <div class="videoPlayer__controls_stop" (click)="playPauseVideo()"><img [src]="playImg" loading="lazy"></div>
        <div class="videoPlayer__controls_timeline" (click)="setTime($event)">
            <div class="videoPlayer__controls_timeline-fill" id="timeline"><span class="oval"></span></div>
        </div>
        <div class="videoPlayer__controls_time">{{duration | timePipe}}</div>
        <div class="videoPlayer__controls_fullscreen" (click)="setFullscreenVideo()"><img [src]="sharedDataService.assetsCdn('images/icons/fullscreen.svg')" loading="lazy"></div>
    </div>
</div>
